/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ClaimImageDTO } from './ClaimImageDTO';
export type ClaimStatementDTO = {
    invoiceId?: string;
    invoiceNo?: string;
    claimId?: string;
    claimNo?: string;
    createdAt?: string;
    customerFirstName?: string;
    customerLastName?: string;
    amount?: number;
    type?: ClaimStatementDTO.type;
    modeType?: ClaimStatementDTO.modeType;
    createdBy?: string;
    createdByFirstName?: string;
    createdByLastName?: string;
    status?: ClaimStatementDTO.status;
    remark?: string;
    slips?: Array<ClaimImageDTO>;
};
export namespace ClaimStatementDTO {
    export enum type {
        NONE = 'NONE',
        DEPOSIT = 'DEPOSIT',
        DEPOSIT_REFUND = 'DEPOSIT_REFUND',
        INSTALLMENT = 'INSTALLMENT',
        FULL_PAYMENT = 'FULL_PAYMENT',
        COMPENSATION = 'COMPENSATION',
        REFUND_COMPENSATION = 'REFUND_COMPENSATION',
        HIRE = 'HIRE',
    }
    export enum modeType {
        NONE = 'NONE',
        CASH = 'CASH',
        PROMPT_PAY = 'PROMPT_PAY',
        BANK_TRANSFER = 'BANK_TRANSFER',
    }
    export enum status {
        SUCCESS = 'SUCCESS',
        CANCEL = 'CANCEL',
    }
}

